import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Shift = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Shift' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,0 L12,24 M2,12 L12,12 M22,12 L12,12 M6,8 L2,12 L6,16 M18,8 L22,12 L18,16' />
  </StyledIcon>
);
